import Short from 'short-uuid';

export default {
  state: {
    data: { token: null, redeemedToken: null },
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'TABLEAU_TOKEN',
      append: '',
      path: 'tableau/token',
      get: { active: true, msg: '' },
      update: { active: false, msg: '' },
      create: { active: false, msg: '' },
      delete: { active: false, msg: '' },
    },
  },
  getters: {
    data: (state) => state.data,
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.data.token = token;
    },
    SET_REDEEMED_TOKEN(state, token = null) {
      state.data.redeemedToken = token !== null ? token : state.data.token;
      console.log('TOKEN REDEEMED');
    },
  },
  actions: {
    SOCKET_TABLEAU_TOKEN({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_TABLEAU_TOKEN`, payload);
      // console.log('TABLEAU_TICKET', payload[1].token);
      // commit('SET_TOKEN', payload[1].token);
      dispatch('INITIATE_CALLBACK', payload);

      // commit('SET_LOADING', false);
    },
    GET_FRESH({ commit, getters }, { callback }) {
      commit('CLEAR_ERROR');

      const rid = Short.uuid();
      commit('ADD_QUEUE', { rid, payload: { ...getters.config.get, msg: '', callback } });
      // eslint-disable-next-line no-underscore-dangle
      this._vm.$socket.client.emit(`${getters.config.default}_GET`, rid);
      // commit('SET_LOADING', true);
    },
  },
};
